import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-resource-electricity-use",
  "use": "svg-icon-resource-electricity-use-usage",
  "viewBox": "0 0 50 50",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\" id=\"svg-icon-resource-electricity-use\"><path d=\"M34.387 22.76h-6.043V10.016c0-1.426-1.793-2.06-2.69-.952L13.34 24.276c-.8.99-.097 2.465 1.176 2.465h6.04v12.75c0 1.425 1.79 2.06 2.686.952l12.32-15.22c.8-.988.097-2.462-1.175-2.462\" fill=\"#F9C73D\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol